var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#4B57E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6465 7.64645C19.8417 7.45118 20.1583 7.45118 20.3536 7.64645L23.3536 10.6464C23.5488 10.8417 23.5488 11.1583 23.3536 11.3536L13.3536 21.3536C13.3057 21.4014 13.2486 21.4391 13.1857 21.4642L8.18571 23.4642C8 23.5385 7.78789 23.495 7.64646 23.3536C7.50503 23.2121 7.46149 23 7.53578 22.8143L9.53578 17.8143C9.56092 17.7514 9.59858 17.6943 9.64646 17.6464L19.6465 7.64645ZM18.7071 10L21 12.2929L22.2929 11L20 8.70711L18.7071 10ZM20.2929 13L18 10.7071L11.5 17.2071V17.5H12C12.2762 17.5 12.5 17.7239 12.5 18V18.5H13C13.2762 18.5 13.5 18.7239 13.5 19V19.5H13.7929L20.2929 13ZM10.5317 18.1755L10.4261 18.281L8.89754 22.1025L12.719 20.5739L12.8246 20.4683C12.635 20.3973 12.5 20.2144 12.5 20V19.5H12C11.7239 19.5 11.5 19.2761 11.5 19V18.5H11C10.7856 18.5 10.6027 18.365 10.5317 18.1755Z",
    fill: "#4B57E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSvg);
export default __webpack_public_path__ + "static/media/editSvg.ae88103df9a5bf630684c7b7f4b0fef0.svg";
export { ForwardRef as ReactComponent };